import { jsx as _jsx } from "react/jsx-runtime";
import { NewRequest } from '@src/components/Employee/PaymentRequests';
import { FullPageWrapper } from '@src/components/FullPageWrapper';
import { useParams } from 'react-router-dom';
export const NewPaymentRequest = () => {
    const { id } = useParams();
    const programId = id ? parseInt(id, 10) : undefined;
    return _jsx(FullPageWrapper, { children: programId && _jsx(NewRequest, { programId: programId }) });
};
